import { css } from '@emotion/css';

const appStyles = {
    root: css`
        height: 100vh;
        overflow-y: auto;
    `,
};

export default appStyles;
